import { action as toggleMenu } from 'redux-burger-menu';

import * as auth from './auth';
import * as banner from './banner';
import * as field from './field';
import * as settings from './settings';
import * as map from './map';

const onLogout = () => dispatch => {
  dispatch(auth.logout());
  dispatch(toggleMenu(false));
};

export { auth, banner, field, map, onLogout, settings };



// WEBPACK FOOTER //
// ./src/actions/index.js